// user, map(s), world; one connection to nchan

import { messageFromBlob } from "./bigintFromblob";

const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const wsRoot = `${protocol}//${window.location.host}/ws`;
const getWsUrl = (playerId: number, mapId: number) =>
  new URL(`${wsRoot}/?channels=player_${playerId},map_${mapId}`);

export class WsConnection {
  player: number;
  connected: boolean = false;
  connection?: WebSocket;
  dataHandler?: (data: Blob) => void;
  mapId: number;
  private backoff = 0;

  constructor(player: number, map: number) {
    this.player = player;
    this.mapId = map;
  }

  connect() {
    setTimeout(() => {
      this.connection = new WebSocket(getWsUrl(this.player, this.mapId));
      this.connection.addEventListener("open", this.onOpen);
      this.connection.addEventListener("close", this.onClose);
      this.connection.addEventListener("error", this.onError);
      this.connection.addEventListener("message", this.onMessage);
    }, this.backoff);
  }

  send(buffer: ArrayBuffer) {
    console.log("sending", buffer);
    this.connection?.send(buffer);
  }

  private reconnectWithExponentialBackoff = () => {
    if (
      this.connected ||
      this.connection?.readyState === this.connection?.CONNECTING ||
      this.connection?.readyState === this.connection?.OPEN
    ) {
      return;
    }
    this.backoff ||= 500;
    this.backoff = Math.min(60_000, this.backoff * 2);

    this.connect();
  };

  private onOpen: EventListenerOrEventListenerObject = (event) => {
    console.log("onOpen", event);
    this.connected = true;
    this.backoff = 0;
  };

  private onClose: EventListenerOrEventListenerObject = (event) => {
    console.log("onClose", event);
    this.connected = false;
    this.reconnectWithExponentialBackoff();
  };

  private onError: EventListenerOrEventListenerObject = (event) => {
    console.log("onError", event);
    this.connected = false;
  };

  private onMessage: EventListenerOrEventListenerObject = async (
    event: Event & { data?: Blob },
  ) => {
    if (!(event.data instanceof Blob)) return;
    this.dataHandler?.(event.data);
  };

  setMessageDataHandler(dataHandler: (data: Blob) => void) {
    this.dataHandler = dataHandler;
  }
}
